import * as React from "react";

import { PageLayout } from "@/shared/components/PageLayout";

import styles from "./Collections.module.css";
import { CollectionsView } from "./CollectionsView";

export const Collections: React.FC = () => {
  return (
    <PageLayout
      title={"Roboto - Collections"}
      headerContentLeft={"Collections"}
    >
      <div className={styles.root}>
        <div className={styles.content}>
          <CollectionsView />
        </div>
      </div>
    </PageLayout>
  );
};
